module.exports = __webpack_public_path__ + "img/memberBuy.b0b3b7df.svg";